import { createSelector } from 'reselect';

// Base selector to get dynamic component state from store
const dynamicComponentStateSelector = (state) => state.dynamicComponents || {};

const dynamicComponentSelector = createSelector(
    dynamicComponentStateSelector,
    (_state, ownProps) => ownProps.sys?.id,
    (_state, ownProps) => ownProps.sid,
    (dynamicComponentState, sysId, sid) => {
        // Use sys.id as primary key, fallback to sid
        // This handles the case where multiple components have the same sid
        const componentKey = sysId || sid;

        const isDynamicComponentInitializing = dynamicComponentState[componentKey] &&
            dynamicComponentState[componentKey].featuresInProgress?.length > 0;

        const dynamicComponent = dynamicComponentState[componentKey]?.data;

        return {
            isDynamicComponentInitializing,
            dynamicComponent
        };
    }
);

export { dynamicComponentSelector };
